import { CoreApi, Product, ProductInfoComponent } from '@inter-ikea-storageone/range';

export const cabinetsSelected = (product: Product, coreApi: CoreApi) => {
  const cabinetsInScene = coreApi.entities.getByProductType(product.type);
  return cabinetsInScene.some(
    cabinet =>
      cabinet.getComponent<ProductInfoComponent>(ProductInfoComponent.id)?.globalArticleNbr ===
      product.globalItemNo
  );
};
